import { Button } from './Button'
import { DESIGN_COPY } from './copy'

export const Pager = ({
  label,
  status,
  onPrevious,
  onNext,
  previousDisabled = false,
  nextDisabled = false,
  previousLabel = DESIGN_COPY.previousPage,
  nextLabel = DESIGN_COPY.nextPage,
}: {
  label: string
  status: string
  onPrevious: () => void
  onNext: () => void
  previousDisabled?: boolean
  nextDisabled?: boolean
  previousLabel?: string
  nextLabel?: string
}) => (
  <nav className="pager" aria-label={label}>
    <Button disabled={previousDisabled} onClick={onPrevious}>
      {previousLabel}
    </Button>
    <p className="pager-status num" role="status">
      {status}
    </p>
    <Button disabled={nextDisabled} onClick={onNext}>
      {nextLabel}
    </Button>
  </nav>
)
